import { useSearchParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Page, PageTitle, Loading, ErrorBox, Empty } from "@/components/site/Common";
import { ProCard } from "@/components/site/ProCard";
import { TRADES } from "@/lib/hz";
import { get } from "@/lib/api";

export default function Pros() {
  const [sp, setSp] = useSearchParams();
  const trade = sp.get("oficio") || "";
  const city = sp.get("ciudad") || "";
  const qs = new URLSearchParams();
  if (trade) qs.set("trade", trade);
  if (city) qs.set("city", city);
  const { data, isLoading, isError } = useQuery({ queryKey: ["pros", trade, city], queryFn: () => get(`/pros?${qs.toString()}`) });
  const setParam = (k, v) => { const n = new URLSearchParams(sp); v ? n.set(k, v) : n.delete(k); setSp(n, { replace: true }); };
  const chip = (active) => `inline-flex h-10 items-center gap-1.5 rounded-full border px-4 text-sm font-semibold transition-colors ${active ? "border-slate-900 bg-slate-900 text-white" : "border-slate-200 bg-white text-slate-700 hover:border-slate-300"}`;

  return (
    <Page>
      <PageTitle eyebrow="Directorio" title="Profesionales verificados" sub="Elige directamente a tu profesional o publica tu trabajo para recibir presupuestos." />
      <div className="mt-8 flex flex-wrap gap-2">
        <button className={chip(!trade)} onClick={() => setParam("oficio", "")} data-testid="filter-trade-all">Todos</button>
        {TRADES.map((t) => (
          <button key={t.id} className={chip(trade === t.id)} onClick={() => setParam("oficio", t.id)} data-testid={`filter-trade-${t.id}`}><t.icon className="size-4" />{t.name}</button>
        ))}
      </div>
      <div className="relative mt-4 max-w-sm">
        <Search className="absolute left-3 top-1/2 size-4 -translate-y-1/2 text-slate-400" />
        <Input value={city} onChange={(e) => setParam("ciudad", e.target.value)} placeholder="Filtrar por ciudad (ej. Madrid)" className="h-11 bg-white pl-9" data-testid="filter-city-input" />
      </div>
      <div className="mt-8">
        {isLoading ? <Loading /> : isError ? <ErrorBox /> : !data.length ? <Empty>No hay profesionales con esos filtros todavía.</Empty> : (
          <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-testid="pros-grid">{data.map((p) => <ProCard key={p.id} pro={p} />)}</div>
        )}
      </div>
    </Page>
  );
}
